/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
/* eslint-disable max-lines-per-function */
import { chain } from "lodash";
import { reverseStateMap } from "components/haven-design/state-picker";

/** Takes a dumb static form and cleans any values before it's passed
 *  on to graphql mutation, used in new/edit(pm)/edit(client)
 */
export const parseDumbInterestForm = (formEl, oldFormData) =>
  chain(formEl.elements)
    .filter(e => e.type !== "submit")
    .reduce((obj, e) => {
      if (e.type === "button") {
        return obj; // ignore buttons
      }
      if (e.tagName === "FIELDSET") return obj; // ignore non-input
      // clean any income fields since they might contain non number chars
      if (e.value.match(/^\$/)) {
        e.value = e.value.replace(/\$|,/g, "");
      }
      if (e.type === "checkbox") {
        // unit size checkboxes handled on the be changeset
        if (e.name.startsWith("unit_size_")) {
          obj[e.name] = e.checked;
        // handle checkbox cases so that when you submit the form,
        // all unchecked boxes won't be set from `null` to `false`
        // which causes noisey diffs on first update
        } else if (oldFormData) {
          if (oldFormData[e.name] === null && e.checked) {
            obj[e.name] = true;
          } else if (oldFormData[e.name] === false && e.checked) {
            obj[e.name] = true;
          } else if (oldFormData[e.name] === true && !e.checked) {
            obj[e.name] = false;
          }
          // we're not using prefilled data so it doesn't matter
        } else {
          obj[e.name] = e.checked;
        }
      } else if (e.type === "radio") {
        if (e.checked) {
          if (e.value === "true") obj[e.name] = true;
          else if (e.value === "false") obj[e.name] = false;
          else {
            obj[e.name] = e.value;

            if (e.name === "unit_size" && e.value) {
              obj[`unit_size_${e.value}`] = true;
            }
          }
        }
      } else {
        obj[e.name] = e.value;
      }

      return obj;
    }, {})
    .mapValues(val => (typeof val === "undefined" || val === "Select" ? null : val))
    .mapValues((val, key) => {
      // if date is empty return null instead of empty string
      switch (key) {
        case "household_member_0_dob":
        case "household_member_1_dob":
        case "household_member_2_dob":
        case "household_member_3_dob":
        case "household_member_4_dob":
        case "household_member_5_dob":
          return val === "" ? null : val;
        case "household_member_0_social":
          return val.replace(/[_-]/g, "");
        case "household_member_0_tax_id_number":
          return val.replace(/[_-]/g, "");
        case "residence_state":
        case "mailing_state":
        case "landlord_state":
        case "contact_state":
          return val && val.length > 2 ? reverseStateMap[val] : val;
        default:
          return val;
      }
    })
    .value();
